
export const COMMON_SET_LOADING = 'COMMON_SET_LOADING';
export const setLoading = (key, isLoading) => ({
    type: COMMON_SET_LOADING,
    isLoading
})

export const COMMON_SET_DATA = 'COMMON_SET_DATA';
export const setData = (key, data) => ({
    type: COMMON_SET_DATA,
    key,
    data
})
export const COMMON_SET_ERROR = 'COMMON_SET_ERROR';
export const setError = (key, error) => ({
    type: COMMON_SET_ERROR,
    key,
    error
})

export const COMMON_INIT_DATA = 'COMMON_INIT_DATA';
export const initData = (key, data) => ({
    type: COMMON_INIT_DATA,
    key,
    data
})

export const loadData = (key, url) => {
    return (dispatch) => {
        return fetch(url)
            .then(function (respone) {
                return respone.json();
            }).then(function (data) {

                dispatch(setData(key, data));
            }).catch(function (err) {
                dispatch(setError(key, err.message));
            });
    }
}

export const loadAllData = (key, urls) => {
    return (dispatch) => {
        const ps = urls.map((url) => {
            return fetch(url)
                .then(function (respone) {
                    return respone.json();
                });
        });
        Promise.all(ps).then((results) => {
            dispatch(setData(key, results));
        }).catch((err) => {
            dispatch(setError(key, err.message));
        })
    }
}



// WEBPACK FOOTER //
// ./_source/cqsx/services/create-service/actions.js